interface Properties {
  width?: number;
  height?: number;
}

const ImportDataIconActive = ({ width = 16, height = 16 }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_684_1042)'>
        <path
          d='M0 39V10.8333C0 6.05363 3.887 2.16663 8.66667 2.16663H13C14.0053 2.16663 15.0107 2.40279 15.9077 2.85129L22.7435 6.27029C23.0425 6.41979 23.3783 6.49779 23.712 6.49779H34.6667C40.6402 6.49779 45.5 11.3576 45.5 17.3311H21.7187C16.003 17.3311 10.8788 21.1575 9.25167 26.6543L3.46017 46.8888C1.34333 44.9106 0 42.1178 0 39ZM50.9015 23.8701C49.8637 22.477 48.282 21.6775 46.5508 21.6493C46.5183 21.6493 46.4923 21.6666 46.4598 21.6666H21.7187C17.9097 21.6666 14.4928 24.2168 13.4117 27.8676L7.306 49.1941C8.4175 49.5798 9.59183 49.8333 10.8333 49.8333H38.0423C42.8653 49.8333 47.034 46.7306 48.4467 42.0181L51.766 28.7668C52.273 27.0725 51.9567 25.2893 50.9015 23.8701Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_684_1042'>
          <rect width='52' height='52' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ImportDataIconActive;
